import React, { useRef } from 'react';

/**
 * 마우스 위치에 따라 카드가 3D로 살짝 기울어지는 공통 패럴럭스 컴포넌트.
 * 대시보드 KPI 카드, 상품 카드형 목록 등에서 재사용한다.
 *
 * className 으로 기존 카드 스타일(.kpi-card, .product-card 등)을 그대로 넘기면 되고,
 * 이 컴포넌트는 그 위에 .parallax-tilt 만 추가로 붙여 기울임 동작을 더한다.
 *
 * 주의: 이전 버전은 내부 콘텐츠를 translateZ 로 살짝 띄우는 "입체감" 레이어가
 * 있었는데, 그러려면 부모에 transform-style: preserve-3d 가 필요했다.
 * preserve-3d 컨텍스트 안에 overflow:hidden + border-radius 를 쓰는 자손이 있으면
 * (예: 상품 카드의 둥근 썸네일 이미지) Chrome/Safari 에서 그 요소가 잘리거나
 * 통째로 사라지는 렌더링 버그가 발생한다. 그래서 그 레이어를 없애고 회전
 * 효과만 남겼다 - 시각적 차이는 미미하지만 훨씬 안정적으로 동작한다.
 */
export default function ParallaxTiltCard({ children, className = '', maxTilt = 8, ...rest }) {
  const ref = useRef(null);

  const handleMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const rotateX = ((y - rect.height / 2) / rect.height) * -maxTilt;
    const rotateY = ((x - rect.width / 2) / rect.width) * maxTilt;
    el.style.transform = `perspective(700px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
  };

  const handleMouseLeave = () => {
    const el = ref.current;
    if (el) el.style.transform = 'perspective(700px) rotateX(0deg) rotateY(0deg)';
  };

  return (
    <div
      ref={ref}
      className={`parallax-tilt ${className}`}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      {...rest}
    >
      {children}
    </div>
  );
}
